var chunkMapping = {
	"3244": [
		33244
	],
	"3323": [
		33323
	]
};
var idToExternalAndNameMapping = {
	"33244": [
		"default",
		"./UserInfo",
		50936
	],
	"33323": [
		"default",
		"./UsersWithSettlement",
		50936
	]
};
var idToRemoteMap = {
	"33244": [
		{
			"externalType": "script",
			"name": "settlement",
			"externalModuleId": 50936
		}
	],
	"33323": [
		{
			"externalType": "script",
			"name": "settlement",
			"externalModuleId": 50936
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}